<div class="wrap-upload column">
    <div class="image-upload">
        <label for="file-input">
            <img [src]="imageUrl" *ngIf="imageUrl">
            <i class="pi pi-plus"> </i>
        </label>
        <input id="file-input" #fileInput type="file" (change)="selectFile($event)" accept="image/*" />
    </div>
    <div class="button-container" >
        <button 
          pButton 
          icon="pi pi-trash" 
          class="delete-button" 
          (click)="deleteImage()">
        </button>
        <button 
          pButton 
          icon="pi pi-pencil" 
          class="delete-button" 
          (click)="triggerFileInputClick(fileInput)">
        </button>
      </div>
    <div [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
</div>